// ContactSection.js - Estatica Skin and Laser
import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/customer/screens/contact/ContactSection.css";

const contactInfo = [
  {
    icon: "📍",
    title: "Clinic",
    value: "14 Wellness Avenue, Medical District",
  },
  {
    icon: "📞",
    title: "Phone",
    value: "+1 (555) 014-2200",
  },
  {
    icon: "✉️",
    title: "Email",
    value: "care@estaticaclinic.co",
  },
];

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Yahan apna API call ya email service laga sakte hain
  };

  return (
    <section className="estatica-contact">
      <Container>
        {/* Heading */}
        <Row>
          <Col lg={6} md={10}>
            <p className="estatica-contact__label">Get In Touch</p>
            <h2 className="estatica-contact__heading">
              We're here to help your skin.
            </h2>
          </Col>
        </Row>

        <Row>
          {/* Left: Form */}
          <Col lg={6} md={12} className="mb-4 mb-lg-0">
            <div className="estatica-contact__form-wrapper">
              <form onSubmit={handleSubmit}>
                <label className="estatica-contact__form-label">Name</label>
                <input
                  type="text"
                  name="name"
                  className="estatica-contact__form-input"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />

                <label className="estatica-contact__form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="estatica-contact__form-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />

                <label className="estatica-contact__form-label">Message</label>
                <textarea
                  name="message"
                  className="estatica-contact__form-textarea"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />

                <button type="submit" className="estatica-contact__submit-btn">
                  Send message
                </button>
              </form>
            </div>
          </Col>

          {/* Right: Info Cards */}
          <Col lg={5} md={12} className="offset-lg-1">
            <div className="estatica-contact__info-wrapper">
              {contactInfo.map((info, index) => (
                <div className="estatica-contact__info-card" key={index}>
                  <span className="estatica-contact__info-icon">
                    {info.icon}
                  </span>
                  <div>
                    <p className="estatica-contact__info-title">{info.title}</p>
                    <p className="estatica-contact__info-value">{info.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactSection;